import * as React from "react";
import { Context } from "./_context";
export const NavigationActivityIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.868 3.868c4.491-4.49 11.773-4.49 16.264 0 4.49 4.491 4.49 11.773 0 16.264-4.491 4.49-11.773 4.49-16.264 0-4.49-4.491-4.49-11.773 0-16.264ZM18.011 5.99A8.5 8.5 0 1 0 5.989 18.012 8.5 8.5 0 0 0 18.011 5.989ZM12.75 7a.25.25 0 0 1 .25.25v4c0 .138.112.25.25.25h3.5a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H11.5A1.5 1.5 0 0 1 10 13V7.25a.25.25 0 0 1 .25-.25h2.5Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationActivityIcon.iconId = "Vo8fvX";
